<template>
  <div v-if="globals.isAccessAllowed('LoopOp_Projects_ReadAll')">
    <!-- This component displays the project management  -->

    <!-- ******************* -->
    <!-- *     Toolbar     * -->
    <!-- ******************* -->
    <!-- This is the panel on top of the page where buttons, pagination and searchbar are displayed -->
    <div class="panel panel-default" id="projects-top-panel">
      <div class="panel-body">
        <div class="col-md-12">
          <!-- Add buttons here  -->
          <button
            id="project-management-refresh-button"
            class="btn btn-raised btn-top-bar"
            :disabled="!refreshEnabled"
            @click="getProjectData()"
          >
            <i class="material-icons md-36">refresh</i>
            <br />
            {{ lang.P0000 }}
          </button>
          <button
            id="project-management-create-button"
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_Projects_Create')"
            @click="
              (selectedProject = -1),
                (editProjectDialogModeAdd = true),
                (showEditProjectDialog = true)
            "
            :disabled="clientList.length < 1"
          >
            <i class="material-icons md-36">add_box</i>
            <br />
            {{ lang.P0001 }}
          </button>
          <button
            id="project-management-edit-button"
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_Projects_Read')"
            @click="
              (editProjectDialogModeAdd = false), (showEditProjectDialog = true)
            "
            :disabled="selectedProject == -1"
          >
            <i class="material-icons md-36">edit</i>
            <br />
            {{ lang.P0002 }}
          </button>
          <button
            id="project-management-delete-button"
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_Projects_Delete')"
            @click="openDeleteProjectDialog()"
            :disabled="selectedProject == -1"
          >
            <i class="material-icons md-36">clear</i>
            <br />
            {{ lang.P0003 }}
          </button>
          <button
            id="project-management-scenario-button"
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_Scenarios_Read')"
            @click="showEditScenarioDialog = true"
            :disabled="selectedProject == -1"
          >
            <i class="material-icons md-36">wallpaper</i>
            <br />
            {{ lang.P0028 }}
          </button>
          <button
            id="project-management-wave-button"
            class="btn btn-raised btn-top-bar"
            v-if="
              globals.isAccessAllowed('LoopOp_ProjectWaves_ReadAll') &&
              globals.isAccessAllowed('LoopOp_ProjectWaves_Read')
            "
            @click="showEditWaveDialog = true"
            :disabled="selectedProject == -1"
          >
            <i class="material-icons md-36">schedule</i>
            <br />
            {{ lang.P0029 }}
          </button>
        </div>
      </div>

      <div class="panel-body">
        <div class="col-lg-7">
          <!-- Searchbar - triggered by enter key -->
          <div class="form-group searchbar">
            <input
              type="search"
              class="form-control"
              id="projectmanagement-inputSearch"
              :placeholder="lang.P0004"
              v-model="filterStrings.Search"
              @keyup.enter="(selectedPage = 1), getProjectData()"
            />
          </div>
        </div>

        <div class="col-lg-5 nopadding">
          <!-- Pagination -->
          <ul class="pagination-fonts pagination btn-group">
            <li>
              <!-- Dropdown: Select the number of elements per page -->
              <a
                role="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                id="elementsPerPageDropdown"
              >
                <i class="material-icons md-18">view_headline</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="elementsPerPageDropdown"
                :delay="globals.tooltipDelay"
                >{{ lang.P0005 }}</b-tooltip
              >
              <ul class="dropdown-menu">
                <!-- Add dropdown entries here -->
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 20 }"
                    role="button"
                    @click="updatePaging(1, 20)"
                    >20</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 50 }"
                    role="button"
                    @click="updatePaging(1, 50)"
                    >50</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 100 }"
                    role="button"
                    @click="updatePaging(1, 100)"
                    >100</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 200 }"
                    role="button"
                    @click="updatePaging(1, 200)"
                    >200</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 500 }"
                    role="button"
                    @click="updatePaging(1, 500)"
                    >500</a
                  >
                </li>
              </ul>
            </li>

            <!-- Jump to first page -->
            <li
              v-bind:class="{ disabled: !pageCount || selectedPage == 1 }"
              @click="updatePaging(1, 0)"
            >
              <a role="button" id="firstPageButton">
                <i class="material-icons md-18">first_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="firstPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.P0006 }}</b-tooltip
              >
            </li>
            <!-- ... -->
            <li v-if="pageCount > 7 && selectedPage > 4" class="disabled">
              <a role="button">...</a>
            </li>
            <!-- Pagenumbers -->
            <li
              v-for="pageNumber in getVisiblePages()"
              :key="pageNumber"
              v-bind:class="{ active: selectedPage == pageNumber }"
              @click="updatePaging(pageNumber, 0)"
            >
              <a role="button">{{ pageNumber }}</a>
            </li>
            <!-- ... -->
            <li
              v-if="pageCount > 7 && selectedPage < pageCount - 3"
              class="disabled"
            >
              <a role="button">...</a>
            </li>
            <!-- Jump to last page -->
            <li
              v-bind:class="{
                disabled: !pageCount || selectedPage == pageCount,
              }"
              @click="updatePaging(pageCount, 0)"
            >
              <a role="button" id="lastPageButton">
                <i class="material-icons md-18">last_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="lastPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.P0007 }}</b-tooltip
              >
            </li>
            <li class="disabled">
              <a role="button" id="projectsTotalElementsCounter">{{
                totalElementsCount
              }}</a>
              <b-tooltip
                ref="tooltip"
                target="projectsTotalElementsCounter"
                :delay="globals.tooltipDelay"
                >{{ lang.P0032 }}</b-tooltip
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- ******************* -->
    <!-- *      Table      * -->
    <!-- ******************* -->
    <!-- This is the main panel on the page where all data is displayed in a table -->
    <div class="panel panel-default">
      <div class="panel-body">
        <div class="table-space main-table-scrollbar">
          <table
            id="projectmanagement-project-list"
            class="table table-striped table-hover main-table"
          >
            <thead>
              <tr>
                <!-- Add table headers here -->
                <!-- The table sort is triggered by click on the header -->
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortProjectData('projectId')"
                  >
                    {{ lang.P0008 }}
                    <span
                      v-if="sortField == 'projectId' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'projectId' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortProjectData('projectName')"
                  >
                    {{ lang.P0009 }}
                    <span
                      v-if="sortField == 'projectName' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'projectName' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  class="text-center sticky-header"
                  v-if="
                    !feature.isAudiTarget ||
                    !feature.isEnabled('audi_importers')
                  "
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="sortProjectData('clientName')"
                  >
                    {{ lang.P0030 }}
                    <span
                      v-if="sortField == 'clientName' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'clientName' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header" v-else>
                  <a
                    class="table-header"
                    role="button"
                    @click="sortProjectData('importerName')"
                  >
                    {{ lang.P0031 }}
                    <span
                      v-if="sortField == 'importerName' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'importerName' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th style="width: 10%" class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortProjectData('ProjectActiveLocationsCount')"
                  >
                    {{ lang.P0010 }}
                    <span
                      v-if="
                        sortField == 'ProjectActiveLocationsCount' &&
                        sortOrder == 'asc'
                      "
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="
                        sortField == 'ProjectActiveLocationsCount' &&
                        sortOrder == 'desc'
                      "
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortProjectData('ProjectTotalLocationsCount')"
                  >
                    {{ lang.P0011 }}
                    <span
                      v-if="
                        sortField == 'ProjectTotalLocationsCount' &&
                        sortOrder == 'asc'
                      "
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="
                        sortField == 'ProjectTotalLocationsCount' &&
                        sortOrder == 'desc'
                      "
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortProjectData('ProjectSurveysCount')"
                  >
                    {{ lang.P0012 }}
                    <span
                      v-if="
                        sortField == 'ProjectSurveysCount' && sortOrder == 'asc'
                      "
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="
                        sortField == 'ProjectSurveysCount' &&
                        sortOrder == 'desc'
                      "
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortProjectData('ProjectSince')"
                  >
                    {{ lang.P0014 }}
                    <span
                      v-if="sortField == 'ProjectSince' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'ProjectSince' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortProjectData('ProjectCreatedBy')"
                  >
                    {{ lang.P0015 }}
                    <span
                      v-if="
                        sortField == 'ProjectCreatedBy' && sortOrder == 'asc'
                      "
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="
                        sortField == 'ProjectCreatedBy' && sortOrder == 'desc'
                      "
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
              </tr>
              <tr class="table-filters">
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.P0016"
                      v-model="filterStrings.ProjectId"
                      @keyup.enter="(selectedPage = 1), getProjectData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.P0016"
                      v-model="filterStrings.ProjectName"
                      @keyup.enter="(selectedPage = 1), getProjectData()"
                    />
                  </div>
                </th>
                <th
                  class="nopadding sticky-filter"
                  v-if="
                    !feature.isAudiTarget ||
                    !feature.isEnabled('audi_importers')
                  "
                >
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.P0016"
                      v-model="filterStrings.ClientName"
                      @keyup.enter="(selectedPage = 1), getProjectData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" v-else>
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.P0016"
                      v-model="filterStrings.ImporterName"
                      @keyup.enter="(selectedPage = 1), getProjectData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.P0016"
                      v-model="filterStrings.ProjectActiveLocationsCount"
                      @keyup.enter="(selectedPage = 1), getProjectData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.P0016"
                      v-model="filterStrings.ProjectTotalLocationsCount"
                      @keyup.enter="(selectedPage = 1), getProjectData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.P0016"
                      v-model="filterStrings.ProjectSurveysCount"
                      @keyup.enter="(selectedPage = 1), getProjectData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.P0016"
                      v-model="filterStrings.ProjectSince"
                      @keyup.enter="(selectedPage = 1), getProjectData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.P0016"
                      v-model="filterStrings.ProjectCreatedBy"
                      @keyup.enter="(selectedPage = 1), getProjectData()"
                    />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- Doubleclick on the table row opens the edit dialog, singleclick selects the project -->
              <tr
                role="button"
                v-for="project in projectData"
                :key="project.ProjectId"
                @click="
                  (selectedProject = project.ProjectId),
                    (clientOfSelectedProject = project.ClientId)
                "
                @dblclick="
                  (editProjectDialogModeAdd = false),
                    (showEditProjectDialog = true)
                "
                :class="{ info: project.ProjectId == selectedProject }"
              >
                <!-- Add table data here -->
                <td>{{ project.ProjectId }}</td>
                <td>{{ project.ProjectName }}</td>
                <td
                  v-if="
                    !feature.isAudiTarget ||
                    !feature.isEnabled('audi_importers')
                  "
                >
                  {{ project.ClientName }}
                </td>
                <td v-else>{{ project.ImporterName }}</td>
                <td>
                  {{ project.ProjectActiveLocationsCount }}
                </td>
                <td>
                  {{ project.ProjectTotalLocationsCount }}
                </td>
                <td>{{ project.ProjectSurveysCount }}</td>
                <td>{{ project.ProjectSince }}</td>
                <td>{{ project.ProjectCreatedBy }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- ******************* -->
    <!-- *      Modal      * -->
    <!-- ******************* -->
    <!-- This modal is for editing or creating new projects -->
    <ProjectManagementEditModal
      :selectedProject="selectedProject"
      :clientList="clientList"
      :surveyList="surveyList"
      :showDialog="showEditProjectDialog"
      :dialogModeAdd="editProjectDialogModeAdd"
      @dialogClosed="onEditProjectDialogClosed"
      @dialogDataSaved="onEditProjectDialogDataSaved"
    ></ProjectManagementEditModal>

    <ScenarioEditModal
      :showDialog="showEditScenarioDialog"
      :selectedProjectData="selectedProjectData"
      :clientList="clientList"
      :selectedClientFromProject="clientOfSelectedProject"
      @dialogClosed="onEditScenarioDialogClosed"
    ></ScenarioEditModal>

    <WaveEditModal
      :showDialog="showEditWaveDialog"
      :selectedClient="clientOfSelectedProject"
      :selectedProjectData="selectedProjectData"
      @dialogClosed="onEditWaveDialogClosed"
    ></WaveEditModal>

    <!-- This modal is for the security check if a user tries to delete any project -->
    <div
      class="modal fade"
      id="deleteProjectDialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal title -->
            <h4 class="modal-title">
              <b>{{ lang.P0019 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <p>
              <b>{{ lang.P0020 }}</b>
            </p>
            <!-- Project data is displayed here to let the user know which project he is about to delete -->
            <div class="form-group">
              <label class="col-md-3 text-black">{{ lang.P0021 }}</label>
              <label class="col-md-9 text-black">{{
                deleteProjectDialogData.ProjectId
              }}</label>
            </div>
            <div class="form-group">
              <label class="col-md-3 text-black">{{ lang.P0022 }}</label>
              <label class="col-md-9 text-black">{{
                deleteProjectDialogData.ProjectName
              }}</label>
            </div>
            <div class="form-group">
              <label class="col-md-3 text-black">{{ lang.P0023 }}</label>
              <label class="col-md-9 text-black">{{
                deleteProjectDialogData.ProjectSince
              }}</label>
            </div>
          </div>
          <div class="modal-footer">
            <!-- Add modal buttons here -->
            <button
              id="deleteFalse"
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.P0024 }}
            </button>
            <button
              id="project-management-delete-true-dialog-button"
              type="button"
              class="btn btn-raised btn-warning"
              @click="deleteProjectData()"
            >
              {{ lang.P0025 }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectManagementEditModal from "./ProjectManagementEditModal";
import ScenarioEditModal from "./ScenarioEditModal";
import WaveEditModal from "./WaveEditModal";

export default {
  name: "ProjectManagement",
  components: {
    ProjectManagementEditModal,
    ScenarioEditModal,
    WaveEditModal,
  },
  mounted() {
    this.readComponentSettingsFromStore();
    // Gets executed right after rendering the component
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.getProjectData();
    }
    this.getEditProjectDialogSelectData();

    // Sets the new table height after the window got resized
    $(window).on("resize", this.setTableHeight).resize();

    if (!this.globals.currentUserInfo)
      this.globals.$once("currentUserInfoReceived", this.setTableHeight);
  },
  destroyed() {
    $(window).off("resize", this.setTableHeight);
    this.writeComponentSettingsToStore();
  },
  methods: {
    setTableHeight() {
      this.$nextTick(() => {
        let height = $(window).height();
        height -=
          $("#projects-top-panel").height() +
          $("#app-navbar").height() +
          // $(".main-table > thead").height() +
          47; // 47 pixel for the free space around the cards
        $(".main-table-scrollbar").css("max-height", height);
        $(".table-space").css("max-height", height);

        //Sets top-property for filter, so it doesnt scroll over table-header
        height = $(".main-table thead tr").height();
        $(".sticky-filter").css("top", height);
      });
    },
    readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      let storedData = this.$store.getters["localFilters/projectManagement"];
      if (storedData) {
        for (let key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      let storedProject = this.$store.getters["sharedFilters/project"];
      this.filterStrings.ProjectName = storedProject.ProjectName || "";

      if (
        !this.feature.isAudiTarget ||
        !this.feature.isEnabled("audi_importers")
      ) {
        let storedClient = this.$store.getters["sharedFilters/client"];
        this.filterStrings.ClientName = storedClient.ClientName || "";
      } else {
        let storedImporter = this.$store.getters["sharedFilters/importer"];
        this.filterStrings.ImporterName = storedImporter.ImporterName || "";
      }
    },
    writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/projectManagement", {
        filterStrings: this.filterStrings,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize,
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      let storedProject = this.$store.getters["sharedFilters/project"];
      if (storedProject.ProjectName !== this.filterStrings.ProjectName) {
        this.$store.commit("sharedFilters/project", {
          ProjectName: this.filterStrings.ProjectName,
        });
      }
      if (
        !this.feature.isAudiTarget ||
        !this.feature.isEnabled("audi_importers")
      ) {
        let storedClient = this.$store.getters["sharedFilters/client"];
        if (storedClient.ClientName !== this.filterStrings.ClientName) {
          this.$store.commit("sharedFilters/client", {
            ClientName: this.filterStrings.ClientName,
          });
        }
      } else {
        let storedImporter = this.$store.getters["sharedFilters/importer"];
        if (storedImporter.ImporterName !== this.filterStrings.ImporterName) {
          this.$store.commit("sharedFilters/importer", {
            ImporterName: this.filterStrings.ImporterName,
          });
        }
      }
    },
    // Gets executed after the editProjectDialog successfully saved some data
    onEditProjectDialogDataSaved(newProjectData) {
      this.getProjectData(); // Refresh datatable
      if (newProjectData.ProjectId) {
        this.selectedProjectData = newProjectData;
        this.selectedProject = newProjectData.ProjectId;
        this.clientOfSelectedProject = newProjectData.ClientId;
      }
    },

    // Gets executed after the editProjectDialog got closed
    onEditProjectDialogClosed() {
      this.showEditProjectDialog = false;
    },

    onEditScenarioDialogClosed() {
      this.showEditScenarioDialog = false;
    },

    onEditWaveDialogClosed() {
      this.showEditWaveDialog = false;
    },

    // Opens the security check dialog for deleting the selected project
    openDeleteProjectDialog() {
      var objIndex = _.findIndex(this.projectData, (o) => {
        return o.ProjectId == this.selectedProject;
      });
      this.deleteProjectDialogData = this.projectData[objIndex];
      $("#deleteProjectDialog").modal("show");
    },

    // Sends a delete request for the selected project to the server
    deleteProjectData() {
      $.ajax({
        method: "DELETE",
        url: "api/Projects/" + this.selectedProject,
        success: (data) => {
          // If delete was successful, refresh displayed data and hide dialog
          this.globals.showSuccessSnackbar("Project deletion successful");
          this.selectedProject = -1;
          this.getProjectData();
          $("#deleteProjectDialog").modal("hide");
        },
        error: () => {
          console.error("Project data deletion failed in deleteProjectData()");
          this.globals.showErrorSnackbar("Project deletion failed");
        },
      });
    },

    // Catch client list
    getClientList() {
      $.ajax({
        method: "GET",
        url: "api/Data/Clients",
        success: (data) => {
          this.clientList = [];
          for (var x in data) {
            this.clientList.push({ ClientId: x, ClientName: data[x] });
          }

          this.clientList.sort((a, b) => {
            // Sort clients by name
            if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase())
              return -1;
            if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase())
              return 1;
            return 0;
          });
        },
        error: () => {
          console.error("Client data access failed in getClientList()");
          this.globals.showErrorSnackbar("Client data access failed");
        },
      });
    },

    // Catch survey list
    getSurveyList() {
      $.ajax({
        method: "GET",
        url: "api/Data/surveys",
        success: (data) => {
          this.surveyList = [];
          if (!_.isEmpty(data)) this.surveyList = data;
        },
        error: () => {
          console.error("Survey data access failed in getSurveyList()");
          this.globals.showErrorSnackbar("Survey data access failed");
        },
      });
    },

    // Catches data for dropdown lists from server
    getEditProjectDialogSelectData() {
      this.getClientList();
      this.getSurveyList();
    },

    // Calculates the sort order for the given column and refreshes the displayed data
    sortProjectData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc"
          ? (this.sortOrder = "desc")
          : (this.sortOrder = "asc");
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.getProjectData();
    },

    // Catches project data for the table from the server, including current filter, pagination and sort settings
    getProjectData() {
      this.refreshEnabled = false;

      let getString = `api/Projects/Get?page_size=${this.pageSize}&page=${this.selectedPage}&sort_column=${this.sortField}&sort_order=${this.sortOrder}`;
      getString = encodeURI(getString);

      let filter = _.pickBy(this.filterStrings, (value, key) => {
        return value.length > 0;
      });

      $.ajax({
        method: "POST",
        url: getString,
        data: _.isEmpty(filter) ? "" : JSON.stringify({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.projectData = data[0].Projects; // If GET was successful, store project data and page count from server
          this.pageCount = data[0].Page_Count;
          this.totalElementsCount = data[0].Count;
        },
        error: () => {
          console.error("Error on POST in getProjectData()");
          this.globals.showErrorSnackbar("Project data access failed");
        },
        complete: () => {
          this.refreshEnabled = true;
        },
      });
    },

    // Updates the current pagesize and the selected pagenumber and triggers the refresh of the table
    updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getProjectData();
    },

    // Returns a range of numbers with min-value, max-value and stepsize
    getRange(min, max, step) {
      var range = [],
        j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },

    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (
        this.pageCount > 7 &&
        this.selectedPage >= this.pageCount - 3
      ) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
  },
  watch: {
    selectedProject(newValue) {
      if (newValue < 0) {
        this.selectedProjectData = {};
        return;
      }
      if (this.selectedProjectData.ProjectId === newValue) return;
      let project = _.find(this.projectData, (p) => {
        return p.ProjectId == newValue;
      });
      if (project) this.selectedProjectData = project;
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
      this.getProjectData();
    },
  },
  data() {
    // Global data inside the component is stored here
    return {
      selectedProject: -1, // ID of the selected project, -1 if none is selected
      selectedProjectData: {},
      clientOfSelectedProject: -1,
      pageSize: 20, // Number of projects on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      pageCount: 0, // Count of available pages depending on the pagesize and the data
      totalElementsCount: 0,
      showEditProjectDialog: false,
      showEditScenarioDialog: false,
      showEditWaveDialog: false,
      editProjectDialogModeAdd: true,
      filterStrings: {
        // Strings that are manipulated by the user for filtering the table
        Search: "",
        ProjectId: "",
        ProjectName: "",
        ClientName: "",
        ImporterName: "",
        ProjectActiveLocationsCount: "",
        ProjectTotalLocationsCount: "",
        ProjectSurveysCount: "",
        ProjectSince: "",
        ProjectCreatedBy: "",
      },
      sortField: "projectName", // Selected column for sorting
      sortOrder: "asc", // Should be "asc" or "desc"
      refreshEnabled: false, // false, if project data is requested and server did not respond yet to avoid multiple requests at the same time
      projectData: [], // Stores the project data on the current page
      clientList: [], // List of all clients
      surveyList: [], // List of all surveys
      deleteProjectDialogData: {}, // Stores data for the deleteProject dialog
      invalidInputIds: [], // IDs of inputs with validation error
      lang: {
        // Contains localization strings for the selected language
        P0000: "Refresh",
        P0001: "Add project",
        P0002: "Edit",
        P0003: "Delete",
        P0004: "Search...",
        P0005: "Items per page",
        P0006: "First page",
        P0007: "Last page",
        P0008: "ProjectID",
        P0009: "Name",
        P0010: "Active locations",
        P0011: "All locations",
        P0012: "Active surveys",
        P0014: "Creation date",
        P0015: "Created by",
        P0016: "Filter",
        P0017: "Add project",
        P0018: "Edit project",
        P0019: "Delete project",
        P0020: "Do you really want to delete the following project?",
        P0021: "ProjectID",
        P0022: "Name",
        P0023: "Created at",
        P0024: "No",
        P0025: "Yes",
        P0026: "Cancel",
        P0027: "Save",
        P0028: "Scenarios",
        P0029: "Waves",
        P0030: "Client",
        P0031: "Importer",
        P0032: "Total projects count",
      },
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// ProjectManagement.vue?22bcb24f